
import { useMemo } from "react";
import { ChatStream } from "@/lib/api/chats";
import { CreateChatStream } from "./CreateChatStream";
import { getUniqueStrings } from "@/lib/utils";

export interface ExtendChatStreamProps {
  chatStream: ChatStream;
  onSuccess?: () => void;
  onClose?: () => void;
}

export function ExtendChatStream({
  chatStream,
  onSuccess,
  onClose
}: ExtendChatStreamProps) {
  const defaultValues = useMemo(() => {
    const participants = chatStream.Participants || [];

    // Extract unique customer IDs
    const customerIds = getUniqueStrings(participants
      .filter(p => p.customer_id)
      .map(p => p.customer_id!));

    // Extract SMS phone numbers that don't have a customer ID (manual phone numbers)
    const phoneNumbers = getUniqueStrings(participants
      .filter(p => p.sms_number && !p.customer_id)
      .map(p => p.sms_number!));

    return {
      name: `${chatStream.name} (Copy)`,
      customerIds,
      phoneNumbers
    };
  }, [chatStream]);

  return (
    <CreateChatStream
      defaultValues={defaultValues}
      onSuccess={onSuccess}
      isOpen={true}
      onClose={onClose}
    />
  );
}
